import React from "react";
import { connect } from "react-redux";
import {closeAddTaskModal} from "../actions";
import mainHelper, {apiCall} from "../helpers/MainHelper";
import ReactLoading from "react-loading";
import Select from "react-select";
class AddTaskModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id:'',
      title: '',
      description: '',
      loading:false,
      employees:[],
      selectedEmployees: []
    };
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  handleSelectChange = (selectedEmployees) => {
    const formattedSelectedOptions = selectedEmployees ? selectedEmployees.map(option => ({
      value: option.value,
      label: option.label
    })) : [];

    this.setState({
      selectedEmployees: formattedSelectedOptions
    });
  };
  handleAddTask = async (event) => {
    event.preventDefault();
    this.setState({loading:true})
    const { status } = this.props.addTaskModalData;

    const { title,description,selectedEmployees } = this.state;
    const formattedSelectedEmployees = selectedEmployees.map(item=>item.value)
    try {
      const response = await apiCall('business/tasks/add','post',
          { title:title, assigned_user_ids:formattedSelectedEmployees, description:description, status:status });

      await this.props.fetchTasks();
      mainHelper.toastMessage('success',response.message);
      this.setState({loading:false})
    }catch (e) {
      this.setState({loading:false})
    }

  };
  render() {
    const { isAddTaskModalOpen,employees} = this.props;
    const { loading,selectedEmployees} = this.state;
    const formattedOptions = employees.map(option => ({
      value: option.id,
      label: option.name+' '+option.surname
    }));
    return (
        <div
            className={isAddTaskModalOpen ? "modal fade show" : "modal fade"}
            role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="title" id="defaultModalLabel">
                  Görev ekle
                </h4>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="form-line">
                    <input
                        name="title"
                        id="title"
                        type="text"
                        className="form-control"
                        placeholder="Görev başlığı"
                        value={this.state.title}
                        onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <Select
                        isMulti
                        placeholder="Atanacak kullanıcıları Seçiniz..."
                        options={formattedOptions}
                        value={selectedEmployees}
                        onChange={this.handleSelectChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="form-line">
                    <textarea
                        name="description"
                        id="description"
                        className="form-control"
                        placeholder="Görev detayı"
                        value={this.state.description}
                        onChange={this.handleInputChange}>
                    </textarea>
                  </div>
                </div>

              </div>
              <div className="modal-footer">

                {loading ? (
                   <button className="btn btn-outline-primary btn-lg" disabled={true}
                            style={{textAlign: "-webkit-center"}}>
                      Lütfen Bekleyin...
                      <ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"/>
                    </button>
                ) : (
                    <button type="button" className="btn btn-outline-primary" onClick={this.handleAddTask}>
                      Ekle
                    </button>
                )}
                <button
                    type="button"
                    onClick={this.props.closeAddTaskModal}
                    className="btn btn-simple"
                    data-dismiss="modal"
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>

        </div>
    );
  }
}

const mapStateToProps = ({mailInboxReducer}) => ({
  isAddTaskModalOpen: mailInboxReducer.isAddTaskModalOpen,
  addTaskModalData: mailInboxReducer.addTaskModalData,
});

export default connect(mapStateToProps, {closeAddTaskModal})(AddTaskModal);
